import React from "react";
import styles from "../../analysis/Charts.module.css";
import layoutStyles from "../../../../styles/utilities/layout.module.css";

export interface ChartHeaderProps {
  title: string;
  subtitle?: string;
  showExpandButton?: boolean;
  onExpand?: () => void;
  expandTitle?: string;
  children?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

// Unified chart header: title + optional subtitle + optional expand button
const ChartHeader: React.FC<ChartHeaderProps> = ({
  title,
  subtitle,
  showExpandButton = false,
  onExpand,
  expandTitle = "Expand chart",
  children,
  className = "",
  titleClassName = "",
}) => {
  return (
    <div
      className={`${layoutStyles.flexRow} ${layoutStyles.itemsStart} ${layoutStyles.justifyBetween} ${layoutStyles.wFull} ${className}`}
    >
      <div className={layoutStyles.flexColumn}>
        <h3 className={`${styles.chartTitle} ${titleClassName}`}>{title}</h3>
        {subtitle && (
          <p
            style={{
              fontSize: "var(--font-size-sm)",
              color: "var(--color-text-muted)",
              marginTop: "var(--spacing-xs)",
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
      {(showExpandButton || children) && (
        <div className={`${layoutStyles.flexRow} ${layoutStyles.itemsCenter} ${layoutStyles.gap2}`}>
          {showExpandButton && (
            <button
              onClick={onExpand}
              className={styles.expandButton}
              title={expandTitle}
              aria-label={expandTitle}
            >
              expand
              <img src="/assets/icons/expand.svg" className={styles.expandIcon} alt="" />
            </button>
          )}
          {children}
        </div>
      )}
    </div>
  );
};

export default ChartHeader;
